"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInstructionsTextarea = exports.StyledEditIconButton = exports.StyledLastEdit = exports.StyledHeaderRight = exports.StyledInstructionsTitle = exports.StyledTitleGroup = exports.StyledInstructionsHeader = exports.StyledInstructionsPanel = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledInstructionsPanel = styled_components_1.default.div `
  padding: 1rem;
  border-bottom: 1px solid ${ui_components_1.baseColors.gray200};
`;
exports.StyledInstructionsHeader = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-bottom: 0.25rem;
`;
exports.StyledTitleGroup = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;
exports.StyledInstructionsTitle = styled_components_1.default.h6 `
  margin: 0;
  font-weight: 600;
  line-height: 160%;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
  font-size: 1rem;
`;
exports.StyledHeaderRight = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
`;
exports.StyledLastEdit = styled_components_1.default.span `
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-left: auto;
  font-size: 0.75rem;
  color: ${ui_components_1.baseColors.primaryBlueMed400};
  white-space: nowrap;
`;
exports.StyledEditIconButton = (0, styled_components_1.default)(material_1.IconButton) `
  padding: 0.25rem;
`;
exports.StyledInstructionsTextarea = styled_components_1.default.textarea `
  width: 100%;
  min-height: 130px;
  padding: 1rem;
  resize: vertical;
  font-family: 'Manrope', sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0;
  color: ${ui_components_1.baseColors.primaryBlueDark500};
  background: transparent;
  border: 1px solid ${({ $isEditing }) => ($isEditing ? ui_components_1.baseColors.primaryGreen300 : ui_components_1.baseColors.gray300)};
  border-radius: 4px;
  outline: none;
  white-space: pre-wrap;
  box-sizing: border-box;

  &:read-only {
    cursor: default;
    resize: none;
  }
`;
